import { useMemo, useRef, useState } from 'react';
import { usePageDataStore } from '@/features/product-editor/pageStore';
import { StanButton, StanUnsplashImageCropSelector, type StanUnsplashImageCropSelectorRef } from '@/components';

export default function StoreCardStyle() {
    const { pageData, updatePageData } = usePageDataStore();

    const currentImageSrc = useMemo(() => {
        return pageData.storePresentation.image;
    }, [pageData]);

    const handleImageChange = (croppedFileUrl: string) => {
        updatePageData({ storePresentation: { image: croppedFileUrl } });
    };

    // Uses local copy of image data, instead of fetching from the server
    const [croppedImageSrc, setCroppedImageSrc] = useState<string | undefined>(undefined);
    const unsplashImageCropSelectorRef = useRef<StanUnsplashImageCropSelectorRef>(null);

    return (
        <div className='grid grid-cols-1 gap-8 lg:grid-cols-2'>
            {/* Form Section */}
            <div className='space-y-6'>
                {!croppedImageSrc && !currentImageSrc && (
                    <div className='space-y-4'>
                        <p className='text-body-md text-gray'>No image selected</p>
                    </div>
                )}

                {(croppedImageSrc || currentImageSrc) && (
                    <>
                        <img
                            src={croppedImageSrc || currentImageSrc}
                            alt='Product Image'
                            className='w-1/2'
                            onLoad={() => {
                                // Clear any memory used by the image blob url
                                URL.revokeObjectURL(croppedImageSrc || '');
                            }}
                        />
                    </>
                )}
                <StanButton name='upload-image' onClick={() => unsplashImageCropSelectorRef.current?.open()}>
                    Select Image
                </StanButton>
                <StanUnsplashImageCropSelector
                    ref={unsplashImageCropSelectorRef}
                    onCropped={(croppedDataUrl: string, croppedFileName: string, croppedFileUrl: string) => {
                        // For usage right away
                        setCroppedImageSrc(croppedDataUrl);
                        // To be uploaded to the server
                        handleImageChange(croppedFileUrl);
                    }}
                />
            </div>
        </div>
    );
}
